var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0625 0.609375C0.875 0.726562 0.78125 0.902344 0.78125 1.15625C0.78125 1.41016 0.875 1.58594 1.0625 1.70312C1.19141 1.78125 1.27734 1.78125 10 1.78125C18.7227 1.78125 18.8086 1.78125 18.9375 1.70312C19.125 1.58594 19.2188 1.41016 19.2188 1.15625C19.2188 0.902344 19.125 0.726562 18.9375 0.609375C18.8086 0.53125 18.7227 0.53125 10 0.53125C1.27734 0.53125 1.19141 0.53125 1.0625 0.609375Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0625 5.60938C0.875 5.72656 0.78125 5.90234 0.78125 6.15625C0.78125 6.41016 0.875 6.58594 1.0625 6.70312C1.1875 6.78125 1.26953 6.78125 5.78125 6.78125C10.293 6.78125 10.375 6.78125 10.5 6.70312C10.6875 6.58594 10.7812 6.41016 10.7812 6.15625C10.7812 5.90234 10.6875 5.72656 10.5 5.60938C10.375 5.53125 10.293 5.53125 5.78125 5.53125C1.26953 5.53125 1.1875 5.53125 1.0625 5.60938Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0625 10.6094C0.875 10.7266 0.78125 10.9023 0.78125 11.1562C0.78125 11.4102 0.875 11.5859 1.0625 11.7031C1.19141 11.7812 1.27734 11.7812 10 11.7812C18.7227 11.7812 18.8086 11.7812 18.9375 11.7031C19.125 11.5859 19.2188 11.4102 19.2188 11.1562C19.2188 10.9023 19.125 10.7266 18.9375 10.6094C18.8086 10.5312 18.7227 10.5312 10 10.5312C1.27734 10.5312 1.19141 10.5312 1.0625 10.6094Z",
    fill: "#585858"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group (3).0fbac9604d1fbe5980aeb405d856880e.svg";
export { ForwardRef as ReactComponent };